
import './CSS/adressage.scss';

export default function Adressage()
{
    return (
        <div className='Page'>
            <h1>Adressage de l'EF9345</h1>

            <p>
                Ce composant est la clef de voûte du VG5000. Si le langage de la machine revient au Z80, toute la partie affichage revient, elle, à l'EF9345.<br/>
                C'est lui qui définit le mode graphique, qui placera un caractère à l'écran, s'occupera des couleurs… c'est ce composant qui fait de cette machine ce qu'elle est.
            </p>
            <p>
                Mais s' il s'occupe de tant de choses, c'est aussi la partie la plus compliquée à comprendre. Aussi la majorité de cette documentation sera dédiée à ce composant.
            </p>

            <h2>
                Les ports
            </h2>

            <p>
                Le VDP est adressable via deux ports:<br/>
                #8F : port de commande.<br/>
                #CF : port de données.
            </p>
            <p>
                Le port #8F vous servira à plusieurs choses : sélectionner un registre, exécuter une commande, mais aussi en lisant ce port, récupérer des informations.
            </p>
            <p>
                Concrètement, on enverra toujours un numéro de registre sur #8F via un OUT avant de lui assigner une valeur via un OUT sur le port #CF.
            </p>

            <h2>
                Les registres
            </h2>

            <p>
                Les registres sont au nombre de 8. Ils sont numérotés à partir de 0. Nous les nommerons Rx. R0 est donc le registre 0, R1 le registre 1, etc.<br/>
                Le numéro de registre a toujours le bit 5 mis à 1. Les valeurs de sélection seront donc respectivement #20, #21, #22, … , #27.</p>

            <p>
                La sélection de registre se fait donc simplement par un out sur le port #8F avec l'une de ces valeurs.
            </p>

            <p>Par exemple pour sélectionner le registre 0, vous pouvez écrire :</p>

            <p className='code'>
                <pre>
                            LD      A,#20<br/>
                            OUT     (#8F),A
                </pre>
            </p>

            <p>
                Le registre sera alors sélectionné et vous pourrez lui assigner une valeur via le port #CF:
            </p>

            <p className='code'>
                <pre>
                LD      A, valeur<br/> 
                OUT     (#CF),A
                </pre>
            </p>

            <p>
                Notez que R0 a une utilité particulière puisqu'il s'agit du registre de commande. Ceci est détaillé dans le chapitre suivant.
            </p>

            <p>
                La plupart des registres ne sont pas modifiés tant qu'on n'y assigne pas d'autres valeurs.<br/>
                Faites donc bien attention lors de l'exécution d'une commande à ce que les valeurs utiles dans les registres soient actualisées.
            </p>

        </div>
    )
}